/*
 * File: ActionModule.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 4, 2025 at 9:49 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled, { css } from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.button`
	display: flex;
	align-items: center;
	gap: 7px;
	background-color: ${({ theme }) => theme.neutralButton};
	border-radius: 16px !important;
	padding: 0px 13px;
	height: 32px;
	border: none;
	cursor: pointer;
	position: relative;

	${({ $center }) => $center && css`
		justify-content: center;
	`}
	&:hover {
		opacity: 0.85;
	}
	span {
		font-size: 0.8rem;
		font-weight: 500;
	}
	&.fontSemibold span {
		font-weight: 600 !important;
	}
	span.fontBold {
		font-weight: 700;
	}
	span.fontRegular {
		font-weight: 500;
	}
	svg {
		font-size: 1.0rem;
	}
`;
